import * as DR from './DateRangeInputTypes';
import { DateRangeInputHandlerProps } from './DateRangeInputHandlers';

/** Can the passed parameter be a valid Date? */
export const isDate = (date: string | Date): boolean => {
  return date instanceof Date ? true : !isNaN(Date.parse(date));
};

/* Format dates to a presentable format. */
export const dateformat = Intl.DateTimeFormat('en-us', {
  month: '2-digit',
  day: '2-digit',
  year: 'numeric',
});

/** Return a new date whose time component has been set to midnight.
 *  From DateInput.
 */
export const truncateToMidnight = (date: Date | undefined): Date | undefined => {
  if (date) {
    const newDate = new Date(date);
    newDate.setHours(0.0, 0.0, 0.0, 0.0);
    return newDate;
  } else {
    return date;
  }
};

/** Helper function to create a new DR.DateRangeInputValues object for the current values. */
export const getNewValues = (
  args: DateRangeInputHandlerProps,
  id: string,
  newValue: Date | boolean | undefined
): DR.DateRangeInputValues => {
  const { allValues, ids } = args;

  if (id === ids[0]) {
    return { start: newValue instanceof Date ? newValue : undefined, end: allValues.end, checked: allValues.checked };
  } else if (id === ids[1]) {
    return { start: allValues.start, end: newValue instanceof Date ? newValue : undefined, checked: allValues.checked };
  } else {
    return {
      start: allValues.start,
      end: allValues.end,
      checked: typeof newValue === 'boolean' ? newValue : undefined,
    };
  }
};
